import type { UserOrganizationAffiliation, AffiliationEntry } from "../affiliations.types";

/**
 * Converts UserOrganizationAffiliation[] (API response) to AffiliationEntry[] (UI format).
 * Includes id and isProtected fields for delete functionality.
 * Filters out affiliations missing an organization. Affiliations with a null role
 * are included so users can populate the role themselves.
 */
export function affiliationsToOrgRoleEntries(
  affiliations: UserOrganizationAffiliation[]
): AffiliationEntry[] {
  return affiliations
    .filter((aff) => aff.organization !== null)
    .map((aff) => ({
      id: aff.id,
      organization: {
        label: aff.organization!.name,
        value: String(aff.organization!.id),
      },
      role: aff.affiliation_role
        ? {
            label: aff.affiliation_role.name,
            value: String(aff.affiliation_role.id),
          }
        : null,
      isProtected: aff.is_used_in_quiz,
    }));
}
